import React, { useEffect, useState } from 'react'
import {
  Container,
  NoMessage,
  SelectedProductsWrapper,
  Div,
  TopRow,
  NoteContainer,
  NoteIcon,
  NoteText
} from './SelectedModels.styles'
import SelectedModel from '../SelectedModel/SelectedModel'
import { Product } from '../../services/types/product'
import { LoadBar } from '../LoadCapacityPercentageBar/LoadCapacityPercentageBar'
import Checkbox from '../CheckBox/Checkbox'
import Button from '../Button/Button'

type SelectedModelsProps = {
  selectedProducts: Product[]
  setSelectedProducts: (products: Product[]) => void
  jobSiteCapacity: number
}

const SelectedModels: React.FC<SelectedModelsProps> = ({
  selectedProducts,
  setSelectedProducts,
  jobSiteCapacity
}) => {
  const [activeProduct, setActiveProduct] = useState('')
  const [percentage, setPercentage] = useState(0)
  const [jobSiteChecked, setJobSiteChecked] = useState<boolean>(false)
  const handleSelectionChange = (productId: string) => {
    setActiveProduct(productId)
  }

  const handleClearSelection = () => {
    setSelectedProducts([])
    setJobSiteChecked(false)
  }

  useEffect(() => {
    const calculatePercentage = () => {
      const total = selectedProducts.reduce((acc, product) => {
        if (product.pointValue === 0 || !product.pointValue) return acc
        if (product.units === 0) return acc
        if (!product.units) return acc
        return acc + (100 / product.FTLQuantity) * product.units
      }, 0)
      if (total === 0) {
        setPercentage(0)
        return
      }
      setPercentage(
        Math.round(total + (jobSiteChecked ? Number(jobSiteCapacity) : 0))
      )
    }
    calculatePercentage()
  }, [selectedProducts, jobSiteChecked, jobSiteCapacity])

  return (
    <Container>
      <LoadBar percentage={percentage} />
      <Div>
        <TopRow>
          <Checkbox
            label="Jobsite order"
            checked={jobSiteChecked}
            setChecked={setJobSiteChecked}
            info="Truckload capacity will be adjusted to allow room for unloading"
          />
          <NoteContainer>
            <NoteIcon>⚠</NoteIcon>
            <NoteText>
              <span className="note-label">Important Note:</span>
              <span className="note-content">
                Fill Percentage is approximate. Each truckload configuration is
                unique and may require minor adjustments once planning is
                complete.
              </span>
            </NoteText>
          </NoteContainer>
          <Button text={'Clear All'} onClick={handleClearSelection} />
        </TopRow>
      </Div>

      <SelectedProductsWrapper>
        {selectedProducts.length === 0 ? (
          <NoMessage>
            <p>No products selected</p>
            <span>
              Please select products from the list to begin the load simulation.
            </span>
          </NoMessage>
        ) : (
          <>
            {selectedProducts.map((product) => (
              <SelectedModel
                key={product.id}
                product={product}
                active={activeProduct === product.id}
                onSelectionChange={handleSelectionChange}
                selectedProducts={selectedProducts}
                setSelectedProducts={setSelectedProducts}
              />
            ))}
          </>
        )}
      </SelectedProductsWrapper>
    </Container>
  )
}

export default SelectedModels
